import React from 'react';
import validator from 'validator';
import cx from 'classnames';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { Checkbox, TextField } from '@wix/wix-ui-tpa/cssVars';
import s from './ProductDeliveryChannels.scss';
import { classes } from '../ProductC2cForm/ProductC2cForm.cssVars.st.css';
import {
  PhoneDeliveryChannel,
  hasSelectedPhoneChannel,
} from '../../../../../phoneDeliveryChannels';
import { useState } from '../../stores';
import { useControllerProps } from '../../ControllerContext';

export const ProductDeliveryChannelsDataHooks = {
  whatsappCheckbox: 'rise-gift-card-send-via-whatsapp-checkbox',
  smsCheckbox: 'rise-gift-card-send-via-sms-checkbox',
  phoneField: 'rise-gift-card-recipient-phone-field',
};

const ProductDeliveryChannels = () => {
  const {
    state: { checkout },
    dispatch,
  } = useState();
  const { t } = useTranslation();
  const { purchase_options_validation, show_errors, setPurchaseOptionsValidation } =
    useControllerProps().giftCardCheckoutStore;
  const { whatsAppSmsGiftCardDeliveryEnabled } =
    useControllerProps().giftCardStore;

  if (!whatsAppSmsGiftCardDeliveryEnabled) {
    return null;
  }

  const { recipientPhone } = checkout.purchaseOptions;
  const phoneDeliveryChannels =
    checkout.purchaseOptions.phoneDeliveryChannels ?? {};
  const showRecipientPhone = hasSelectedPhoneChannel(phoneDeliveryChannels);

  const toggleChannel = (channel: PhoneDeliveryChannel) =>
    dispatch({
      type: 'setPurchaseOptions',
      payload: {
        phoneDeliveryChannels: {
          ...phoneDeliveryChannels,
          [channel]: !phoneDeliveryChannels[channel],
        },
      },
    });

  return (
    <div className={s.container}>
      <div className={s.checkboxRow}>
        <div className={s.checkboxContainer}>
          <Checkbox
            data-hook={ProductDeliveryChannelsDataHooks.whatsappCheckbox}
            label={t('giftCardPage.sendViaWhatsapp.label')}
            checked={!!phoneDeliveryChannels[PhoneDeliveryChannel.WhatsApp]}
            onChange={() => toggleChannel(PhoneDeliveryChannel.WhatsApp)}
          />
        </div>
        <div className={s.checkboxContainer}>
          <Checkbox
            data-hook={ProductDeliveryChannelsDataHooks.smsCheckbox}
            label={t('giftCardPage.sendViaSms.label')}
            checked={!!phoneDeliveryChannels[PhoneDeliveryChannel.SMS]}
            onChange={() => toggleChannel(PhoneDeliveryChannel.SMS)}
          />
        </div>
      </div>
      {showRecipientPhone && (
        <div className={s.textFieldContainer}>
          <TextField
            type="tel"
            inputMode="tel"
            data-hook={ProductDeliveryChannelsDataHooks.phoneField}
            maxLength={40}
            className={cx(s.textField, classes.textField)}
            value={recipientPhone}
            label={t('giftCardPage.recipientPhoneNumber.label')}
            placeholder={t('giftCardPage.recipientPhoneNumber.placeholder')}
            errorMessage={t(
              recipientPhone
                ? 'giftCardPage.recipientPhoneNumber.invalidNumber.error'
                : 'giftCardPage.recipientPhoneNumber.emptyNumber.error',
            )}
            error={show_errors && !purchase_options_validation.recipientPhone}
            autoComplete="tel"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const value = e.target.value;
              dispatch({
                type: 'setPurchaseOptions',
                payload: { recipientPhone: value },
              });
              setPurchaseOptionsValidation(
                'recipientPhone',
                validator.isMobilePhone(value, 'any', { strictMode: true }),
              );
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ProductDeliveryChannels;
